// Подтверждение простоев и утренний обзвон: /api/v2/confirm/* (erp-backend, модуль src/confirm).
import { useAxiosCreate } from '@/backend/utils.js'

const api = useAxiosCreate('api')

export async function fetchMyChecks() {
  const { data } = await api.get('confirm/my')
  return data
}

export async function answerCheck(id, { answer, leftAt, comment }) {
  const { data } = await api.post('confirm/' + id + '/answer', {
    answer,
    left_at: leftAt || null,
    comment: comment || null,
  })
  return data
}

export async function fetchOutbox(status) {
  const { data } = await api.get('confirm/outbox', { params: status ? { status } : {} })
  return data
}

export async function decideOutbox(id, approve) {
  const { data } = await api.post('confirm/outbox/' + id + '/decision', { approve })
  return data
}
